import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRole } from '../models/user.model';
import { AuthService } from '../services/auth.service';

/**
 * Guard to protect routes based on user roles
 * Usage: canActivate: [roleGuard], data: { roles: [UserRole.SUPER_ADMIN, UserRole.CONSULTANT] }
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if user is authenticated
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Get required roles from route data
  const requiredRoles = route.data['roles'] as UserRole[] | undefined;

  // If no roles specified, allow access (just need authentication)
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  // Check if user has any of the required roles
  const hasRole = authService.hasAnyRole(requiredRoles);
  console.log('[RoleGuard] Checking roles:', {
    currentUserRole: authService.userRole(),
    requiredRoles,
    hasRole
  });

  if (hasRole) {
    return true;
  }

  console.warn('[RoleGuard] Access denied. Redirecting to dashboard.', {
    userRole: authService.userRole(),
    required: requiredRoles
  });

  // User doesn't have required role, redirect to dashboard or 403
  return router.createUrlTree(['/dashboard']);
};
